import { configureStore } from "@reduxjs/toolkit";
import { createSocketTypeMiddleware } from "../middlewares/socketMiddleware";
import authSlice from "../Slice/authSlice";
import radioInfoSlice from "../Slice/radioInfoSlice";
import modalSlice from "../Slice/modalSlice";
import trackInfoSlice from "../Slice/trackInfoSlice";
import pollInfoSlice from "../Slice/eventSlice";
import playlistReleasesSlice from "../Slice/playlistReleasesSlice";
import playerSlice from "../Slice/playerSlice";
import metaTagsSlice from "../Slice/metaTagsSlice";
import { podcastsApi } from "../../api/podcastsApi";
import releasePodcastInfoSlice from "../Slice/releasePodcastSlice";
import { bannersApi } from "../../api/bannersApi";
import { tracksApi } from "../../api/tracksApi";

const waves = ["rock", "mc", "lite"];

const arrayMiddleware = waves.map(createSocketTypeMiddleware);

export const store = configureStore({
  reducer: {
    [podcastsApi.reducerPath]: podcastsApi.reducer,
    [bannersApi.reducerPath]: bannersApi.reducer,
    [tracksApi.reducerPath]: tracksApi.reducer,
    playlistReleases: playlistReleasesSlice,
    player: playerSlice,
    modalSlice,
    radioInfo: radioInfoSlice,
    auth: authSlice,
    trackInfo: trackInfoSlice,
    eventInfo: pollInfoSlice,
    releasePodcastInfo: releasePodcastInfoSlice,
    metaTagsSlice,
  },
  devTools: process.env.NODE_ENV === "development",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      podcastsApi.middleware,
      bannersApi.middleware,
      tracksApi.middleware,
      ...arrayMiddleware,
    ]),
});

/**
 * @typedef {ReturnType<typeof store.getState>} StoreApp
 */

// store.subscribe(() => {
//   localStorage.setItem("reduxState", JSON.stringify(store.getState()));
// });

// const persistedState = localStorage.getItem("reduxState")
//   ? JSON.parse(localStorage.getItem("reduxState"))
//   : {};
